import {React, useEffect, useState} from 'react';
import axios from 'axios';
import { Layout, Row, Col } from 'antd';
import MetaTags from 'react-meta-tags';
import TopContainer from '../components/TopContainer';
import CatCardContainer from '../components/CatCardContainer';
import HomePageSider from '../components/HomePageSider';
import FeaturedPracticeSection from '../components/FeaturedPracticeSection';
import ExamCategories from '../components/ExamCategories';
import WorkingScheme from '../components/WorkingScheme';
import SuccessStories from '../components/SuccessStories';
import AceExams from '../components/AceExams';
import PricingPlans from '../components/PricingPlans';
import FaqSection from '../components/FaqSection';
import Footer from '../components/Footer';
import '../styles/homepage.css'


const HomePage = () => {
    const { Sider, Content } = Layout;


    const [allCategories, setAllCategories] = useState({}); 
    const [allSubCategories, setAllSubCategories] = useState({});    
    
    const getAllCategories = async () =>  {
         try {
            const response = await axios.get('https://epolylearning.com/Services/polyquiz.svc/allcategories');
            const catData = response.data.CategoryList;
            setAllCategories(catData);
        } catch (error) {
            console.log(error);
        } 
    }

    const getAllSubCategories = async () =>  {
      try {
         const response = await axios.get('https://epolylearning.com/Services/polyquiz.svc/allsubcategories');
         const subCatData = response.data.SubCategoryList;
         setAllSubCategories(subCatData);
     } catch (error) {
         console.log(error);
     } 
 }
    
    useEffect(() => {
       getAllCategories();  
       getAllSubCategories();
    }, []);

      useEffect(() => {
      // use 'instant' to jump immediately, or 'smooth' if you prefer
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, []);


  return (
    <>


<MetaTags>
            <title>PolyQuiz - Free Online Quiz Tests for everyone.</title>
            <meta id="meta-description" name="description" 
            content="Access free Online Quizzes and Tests for competitive exams on
            variety of topics like Aptitude online quiz, Logical Reasoning online quiz, General Knowledge online quiz
            Biology online quiz, Chemistry quiz, Data Interpretation quiz and many more." />
    
</MetaTags>
    
    <Layout>
        
   
  
 
   <Content><TopContainer />
    <FeaturedPracticeSection /> 
    {/* < ExamCategories /> */}
    <AceExams />
    <WorkingScheme />
    <SuccessStories />
   {/* <PricingPlans /> */}
   <FaqSection />
   {/* <Footer /> */}
      </Content>
   {/* <Layout className='sidebar'>
     <Row><Col  xs={0} sm={0} md={4} lg={4}>
        <Sider collapsedWidth={0}><HomePageSider allCategories = {allCategories} allSubCategories = {allSubCategories} /></Sider>
        </Col></Row>
        <Content id='home-content'> <CatCardContainer allCategories = {allCategories} /></Content>
      </Layout> */}
     

   </Layout>  
    
    </>
  )
}

export default HomePage